<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <toolbar_visualizar v-if="form.id != null && form.id != undefined" :item="form"></toolbar_visualizar>
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">{{titulo_tela}}</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label
                class="md-layout-item md-size-10 md-small-size-15 md-xsmall-size-30 md-form-label"
              >Data/Hora</label>
              <div class="md-layout-item md-size-15 md-small-size-35 md-xsmall-size-70">
                <md-field>
                  <datepicker
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="data"
                    v-model="data"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                  ></datepicker>
                </md-field>

                <span class="error_input">{{ getErrors('data') }}</span>
              </div>

              <label
                class="md-layout-item md-size-10 md-small-size-15 md-xsmall-size-30 md-form-label"
              >Entrada</label>
              <div class="md-layout-item md-size-15 md-small-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="entrada"
                    type="text"
                    placeholder="HH:mm"
                    v-mask="'##:##'"
                    v-model="form.entrada"
                  ></md-input>
                </md-field>
              </div>

              <label
                class="md-layout-item md-size-10 md-small-size-15 md-xsmall-size-30 md-form-label"
              >Saída</label>
              <div class="md-layout-item md-size-15 md-small-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="saida"
                    type="text"
                    placeholder="HH:mm"
                    v-mask="'##:##'"
                    v-model="form.saida"
                  ></md-input>
                </md-field>
              </div>

              <label
                class="md-layout-item md-size-10 md-small-size-15 md-xsmall-size-30 md-form-label"
                v-if="form.id != null"
              >ID:</label>
              <div
                class="md-layout-item md-size-15 md-small-size-35 md-xsmall-size-70"
                v-if="form.id != null"
              >
                <md-field>{{form.id}}</md-field>
              </div>
            </div>

            <div class="md-layout" v-if="montado" >
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Cliente / Estabelecimento</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select 
                    class="vue-select2"
                    name="sel_id_cliente"
                    :options="items_clientes"
                    v-model="form.id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    :onChange="loadUnidade"
                    :placeholder="placeholder_cliente"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Unidade</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select_unidade"
                    :options="items_unidade"
                    v-model="form.id_estabelecimento"
                    :searchable="true"
                    language="pt-BR"
                    :placeholder="placeholder_unidade"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_estabelecimento') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="form.id != null && form.data_cadastro != null">
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Data de Cadastro</label>
              <div class="md-layout-item md-size-85 md-small-size-85 md-xsmall-size-70">
                <md-field>{{form.data_cadastro | datetime_show}}</md-field>
              </div>
            </div>

            <div class="md-layout">
              <label
                class="md-layout-item md-size-15 md-small-size-15 md-xsmall-size-30 md-form-label"
              >Responsável Controlare</label>
              <div class="md-layout-item md-size-35 md-small-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    v-if="loaded_profissional"
                    class="vue-select2"
                    name="select_profissional"
                    :options="items_profissional"
                    v-model="form.id_resp_controllare"
                    :searchable="true"
                    language="pt-BR"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_resp_controllare') }}</span>
              </div>
              <label
                class="md-layout-item md-size-15 md-small-size-15 md-xsmall-size-30 md-form-label"
              >Nutricionista Responsável</label>
              <div class="md-layout-item md-size-35 md-small-size-85 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="nutricionista_responsavel"
                    type="text"
                    placeholder="Nutricionista Responsável"
                    v-model="form.nutricionista_responsavel"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nutricionista_responsavel') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Nome / Assinatura do responsável pelo estabelecimento</label>
              <div class="md-layout-item md-size-50 md-small-size-85 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="responsavel_estabelecimento"
                    type="text"
                    placeholder="Nome / Assinatura do responsável pelo estabelecimento"
                    v-model="form.responsavel_estabelecimento"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('responsavel_estabelecimento') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Status</label>
              <div class="md-layout-item md-size-50 md-small-size-85 md-xsmall-size-70">
                <md-field>
                  <campo_status v-model="form.status"></campo_status>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div v-if="tipo != null && parseInt(tipo)==2" class="md-layout-item md-size-100">
        <comp_item_produto_nao_conforme_cad
          tabela="relatorio"
          v-model="form.produtos"
          v-if="form.id != null"
          :id_pai="form.id"
        ></comp_item_produto_nao_conforme_cad>
      </div>

      <div
        class="md-layout-item md-size-100"
        v-if="form.textos != null && form.textos != undefined"
      >
        <textos v-model="form.textos"></textos>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>
          <botao_publicar :onClick="salvar" :disableButton="false" :status="form.status"></botao_publicar>
          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>

    <div v-if="form.id != null && parseInt(form.id) > 0">
      <uploadfolder :id_registro="form.id" :titulo="titulo_tela" id_tabela="relatorio"></uploadfolder>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/RelatorioService";

import serviceCliente from "../../../services/ClienteService";
import serviceEstabelecimento from "../../../services/EstabelecimentoService";
import serviceNutricionista from "../../../services/NutricionistaService";

import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Util from "../../../library/Util";
import Alerta from "../../../library/Alerta";
import Mask from "../../../library/Mask.js";

import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";

import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import comp_item_produto_nao_conforme_cad from "../item_produto_nao_conforme/comp_item_produto_nao_conforme_cad";
import Textos from "./Textos.vue";

import uploadfolder from "../../components/images/uploadFolder";
//import vue_select from '../../../components/Rend/vue-select2/Select.vue';

import toolbar_visualizar from "../../area/components/toolbar_visualizar";
import campo_status from "../../components/campo_status";
import botao_publicar from "../../components/botao_publicar";

export default {
  components: {
    autocomplete: autocomplete,
    filelogo: filelogo,
    modal: modal,
    Datepicker: Datepicker,
    CardCadastro: CardCadastro,
    vue_select: vue_select,
    comp_item_produto_nao_conforme_cad: comp_item_produto_nao_conforme_cad,
    textos: Textos,
    uploadfolder: uploadfolder,
    toolbar_visualizar: toolbar_visualizar,
    campo_status: campo_status,
    botao_publicar: botao_publicar
  },

  mixins: [mixin_util, mixin_validator],
  // props: ['id_load', 'show_back_button','onBack', 'onSave'],

  props: {
    id_load: { type: Number, default: null },

    show_back_button: { type: String, default: "true" },

    onBack: { type: Function, default: null },

    onSave: { type: Function, default: null },

    tipo: { type: String, default: "1" }
  },
  watch: {
    //id_cliente (val){
    //     if ( this.montado ){
    //         this.loadUnidade();
    //     }
    // }
  },
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,

      id_cliente: null,
      data_cadastro: null,
      data: null,
      data_entrada: null,
      data_saida: null,

      items_clientes: [],
      items_unidade: [],
      items_profissional: [],

      language_date: ptBR,
      montado: false,

      loaded_cliente: false,
      loaded_unidade: false,
      loaded_profissional: false,

      placeholder_cliente: "..Carregando clientes",
      placeholder_unidade: "Selecione o cliente",
      titulo_tela: "",
      toolbar: null,
      show_cliente: false,
    };
  },
  async mounted() {
    let user = JSON.parse(window.obj_user.getUser());
    let self = this;

    this.titulo_tela = service.getTitulo(this.tipo);
    this.form = service.getModel(parseInt(this.tipo));

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    self.placeholder_cliente = "..Carregando clientes";

    /* serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );
      self.loaded_cliente = true;
      self.placeholder_cliente = "Cliente (digite para pesquisar) ";
    });   */

    this.show_cliente = false;
    var response = await serviceCliente.getList2("", "nome", "asc");
    self.items_clientes = Util.getListToSelect( response.data.data, "id", "nome");
    self.loaded_cliente = true;
    self.placeholder_cliente = "Cliente (digite para pesquisar) ";

    this.loadProfissional();

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getById(this.id_load).then(function(response) {
        //console.log( response.data );

        /* if ( response.data.data != null && response.data.data != undefined ){
                                                   			self.form = response.data.data;

                        				}else{
                                                   			self.form = response.data.item;

                                                        } */
        self.form = response.data;
        self.id_cliente = self.form.id_cliente;
        self.toolbar = response.data.toolbar;

        if (self.form.data_cadastro != null) {
          var intData = self.getApiDateInt(self.form.data_cadastro);

          self.data_cadastro = new Date(intData);
        }
        if (self.form.data != null) {
          var intData = self.getApiDateInt(self.form.data);

          self.data = new Date(intData);
        }
        if (self.form.data_entrada != null) {
          var intData = self.getApiDateInt(self.form.data_entrada);

          self.data_entrada = new Date(intData);
        }
        if (self.form.data_saida != null) {
          var intData = self.getApiDateInt(self.form.data_saida);

          self.data_saida = new Date(intData);
        }
        setTimeout( () => self.loading = false, 100 );
        self.disableButton = false;
        self.loadUnidade();
        self.montado = true;

        if (
          self.form.status == 1 &&
          user.perfil.toLowerCase().indexOf("administrador") < 0 &&
          user.perfil.toLowerCase().indexOf("supervisor") < 0
        ) {
          self.disableButton = true;
        }
      });
    } else {
      this.loading = false;
      this.disableButton = false;
      this.montado = true;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "relatorio",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    loadUnidade() {
      var self = this;

      console.log("unidade?");
      this.id_cliente = this.form.id_cliente;

      if (this.id_cliente == null) {
        self.items_unidade = [];
        self.placeholder_unidade = "Selecione o cliente";
        return false;
      }

      self.placeholder_unidade = "..Carregando unidades";
      serviceEstabelecimento
        .getListByParent("cliente", this.id_cliente)
        .then(function(response) {
          self.items_unidade = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );
          self.placeholder_unidade = "Unidades (digite para pesquisar)";
        });
    },

    loadUnidade_old() {
      var self = this;

      if (this.id_cliente == null) {
        self.items_unidade = [];
        return false;
      }

      serviceEstabelecimento
        .getListByParent("cliente", this.id_cliente)
        .then(function(response) {
          console.log("unidades?");
          console.log(response.data);
          self.items_unidade = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );
          self.loaded_unidade = true;
          self.placeholder_unidade = "Unidades (digite para pesquisar)";
        });
    },

    loadProfissional() {
      var self = this;

      serviceNutricionista.getList("", "nome", "asc").then(function(response) {
        //  console.log("carreguei nutricionista"); console.log(  Util.getListToSelect(  response.data,"id","nome") );

        self.items_profissional = Util.getListToSelect(
          response.data,
          "id",
          "nome"
        );
        self.loaded_profissional = true;
      });
      //items_profissional
    },

    datepicker_inputchanged(value) {},

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        data: {
          required: "Informe a data!",
          internal: true
        },
        id_cliente: {
          required: "Selecione o cliente!",
          internal: true
        },
        id_estabelecimento: {
          required: "Selecione a unidade!",
          internal: true
        },
        id_resp_controllare: {
          required: "Selecione o responsável controlare!",
          internal: true
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar(prop_status, prop_nome_perfil) {
      var self = this;

      this.form.data = this.data;
      // this.form.id_cliente = this.id_cliente;
      this.form.tipo = this.tipo;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;
      // self.data_cadastro = Util.dateToBd(  self.data_cadastro );
      self.form.data = Util.dateToBd(self.data);
      // self.data_entrada = Util.dateToBd(  self.data_entrada );
      // self.data_saida = Util.dateToBd(  self.data_saida );

      // this.form.id_cliente = this.id_cliente;

      if (
        prop_status != null &&
        prop_status != undefined &&
        typeof prop_status == "number"
      ) {
        this.form.status = prop_status;
      }

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text =
            service.getTitulo(self.tipo) + " salva com sucesso!";

          setTimeout(self.clear_message, 6000);

          //self.interval_message = setInterval(self.clear_message, 6000);

          //var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = retorno;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {
          console.log("Erro ao tentar salvar");
          console.log(error);
        });
    },

    excluir() {
      let self = this;

      Alerta.confirm(
        "Atenção",
        "Deseja realmente excluir?",
        "question",
        function() {
          self.msg_status = "Excluindo..";
          self.loading = true;

          var fn_return = function(response) {
            var retorno = response.data;
            if (self.onSave != null && self.onSave != undefined) {
              self.onSave(retorno, "delete");
            }
            self.msg_status = "Carregando..";
            self.loading = false;
            self.botao_voltar();
          };
          if (self.form.id == null) return false;

          service.delete(self.form.id).then(fn_return);
        },
        null
      );
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>